var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cog-stripe-card-placeholder cog-field" }, [
    _vm.mobile
      ? _c(
          "div",
          { staticClass: "cog-stripe-card-placeholder__payment-type cog-row" },
          [_vm._m(0), _vm._v(" "), _vm._m(1)]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "cog-field__placeholder cog-input cog-input--tiny" },
      [
        _c("div", { staticClass: "cog-field__placeholder-inner" }, [
          _vm._v(" ")
        ])
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "cog-field__placeholder cog-input cog-input--tiny" },
      [
        _c("div", { staticClass: "cog-field__placeholder-inner" }, [
          _vm._v(" ")
        ])
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cog-field__placeholder cog-input" }, [
      _c("div", { staticClass: "cog-field__placeholder-inner" }, [_vm._v(" ")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cog-row" }, [
      _c(
        "div",
        { staticClass: "cog-field__placeholder cog-input cog-input--long" },
        [
          _c("div", { staticClass: "cog-field__placeholder-inner" }, [
            _vm._v(" ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cog-field__placeholder cog-input cog-input--long" },
        [
          _c("div", { staticClass: "cog-field__placeholder-inner" }, [
            _vm._v(" ")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }